import * as React from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";
import {
    CONTROLROOM_TABLE_HEADER_HEIGHT,
    CONTROLROOM_TABLE_ROW_HEIGHT,
    ControlRoomTableDispatchProperties,
    ControlRoomTableStateProperties,
    createBasicTableComponent,
    ControlRoomTableProperties,
} from "../common/ui/table/ControlRoomTable";
import {isFinished} from "../common/util/asyncdata/reducerUtil";
import {AOIMonitor as Notification} from "./model";
import {selectors} from "./selectors";
import {actions} from "./actions";
import {NotificationColumns} from "./NotificationColumns";

export const serviceContentListDimensions = (parent: HTMLElement) => {
    return {
        width: parent.clientWidth,
        height: 8 * CONTROLROOM_TABLE_ROW_HEIGHT + CONTROLROOM_TABLE_HEADER_HEIGHT,
    };
};

export const NotificationsListComponent = createBasicTableComponent(NotificationColumns, serviceContentListDimensions);

const mapStateToProps = (state, _ownProps: Partial<ControlRoomTableProperties<Notification>>): ControlRoomTableStateProperties<Notification> => {
    return {
        data: selectors.getAllNotifications(state),
        isPaged: false,
        isAllDataLoaded: isFinished(selectors.getNotificationRequestState(state)),
        noItemsFoundMessage: <FormattedMessage id="studio.notifications-list.no-items"
                                               defaultMessage="No AOI users found."/>,
    };
};

const mapDispatchToProps = (dispatch): ControlRoomTableDispatchProperties<Notification> => {
    return {
        loadData: () => {
            dispatch(actions.loadNotifications());
        },
    };
};
export const NotificationsList = connect(mapStateToProps, mapDispatchToProps)(injectIntl(NotificationsListComponent));